import {
    buildSchema,
} from "@camberi/firecms";

const userSchema = buildSchema({
    name: "users",
    properties: {
        name: {
            dataType: "string",
            title: "Name",
            disabled: true,
            validation: {
                required: true,

            }
        },
        email: {
            dataType: "string",
            title: "Email",
            disabled: true,
            validation: {
                required: true
            }
        },
        phone: {
            dataType: "string",
            title: "Phone",
            disabled: true,
            validation: {
                required: true
            }
        },
        photourl: {
            dataType: "string",
            title: "Photo Url",
            disabled: true,
            validation: {
                required: true
            },
            config: {
                url: true,
            }
        },
        referral_code: {
            dataType: "string",
            title: "Referral Code",
            disabled: true,
            validation: {
                required: true
            }
        },
        firstregister: {
            dataType: "number",
            title: "First Register",
            disabled: true,
            validation: {
                required: true
            }
        },
        notification_enabled: {
            dataType: "boolean",
            title: "Notification Enabled",
            disabled: true,
            validation: {
                required: true
            }
        },

        total_event_attended: {
            dataType: "number",
            title: "Events Attended",

        },
        session_history_count: {
            dataType: "number",
            title: "Sessions Played",

        },
        created_at: {
            dataType: "timestamp",
            title: "Created At",
            disabled: true,

        },
        last_logged_in: {
            dataType: "timestamp",
            title: "Last Logged In",
            disabled: true,

        },
    }
});

userSchema.onSaveSuccess = () => {
    console.log("onSaveSuccess");
};

export default userSchema;